import 'slick-carousel';
import 'ez-plus';

/**
 * Initialize product slider
 * @param  {String} slider - Main product slider selector
 * @param  {String} thumbs - Thumbs product slider selector
 * @return {Void}
 */

export const init = (slider = '.js-product-slider', thumbs = '.js-product-slider-thumbs') => {
	let thumbsConfig = {};

	const config = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		adaptiveHeight: false,
		asNavFor: thumbs,
		fade: true
	};

	if($('.template-product').length) {
		thumbsConfig = {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			vertical: true,
			adaptiveHeight: false,
			arrows: false,
			fade: true
		}
	}

	$(slider)
		.not('.slick-initialized')
		.slick(config);
	$(thumbs)
		.not('.slick-initialized')
		.slick(thumbsConfig);
};

const ezPlusOptions = {
  borderSize: 1,
  // responsive: true,
  constrainType: 'height',
  constrainSize: 150,
  zoomType: 'inner',
  containLensZoom: true,
  cursor: 'crosshair',
  zIndex: 9,
};

if ($('.js-product__image, .js-product__image-main').length) {
	$('.js-product__image, .js-product__image-main').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: false,
		draggable: false,
		swipeToSlide: false,
		dots: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					draggable: true,
					swipeToSlide: true,
				},
			},
		],
	});

	$(window).on('load resize', function () {
		setTimeout(() => {
			$('.zoomContainer').remove();
			$('.slick-current img').ezPlus(ezPlusOptions);
		}, 200);
	})

	$(document).on(
		'click',
		'.js-product__slider-next, .js-product__slider-prev',
		function (e) {
			e.preventDefault();
			let command = $(e.target).hasClass('js-product__slider-next') ? 'slickNext' : 'slickPrev'

			$('.js-product__image.slick-initialized, .js-product__image-main.slick-initialized').slick(command);

			$('.slick-current img').ezPlus(ezPlusOptions);
		}
	);

	/**
	 * Handle product slider popup
	 * @param {String} slider Selector
	 */
	const sliderPopup = (slider = '.js-product-slider') => {
		$(document).on('click', `${slider} .slick-slide`, function () {
			$(this)
        .closest(slider)
        .addClass('is-popup')
        .parent()
        .addClass('is-popup');

			$('.product__slider-controls').addClass('is-popup');
			$(this).closest(slider).slick('setPosition');
		});

		$(document).on('click', '.js-slider-popup-close', function (e) {
			e.preventDefault();
			$(slider)
				.removeClass('is-popup')
				.parent()
				.removeClass('is-popup');

			$('.product__slider-controls').removeClass('is-popup');
			$(slider).slick('setPosition');
			$('.slick-current img').ezPlus(ezPlusOptions);
		});
	};

	sliderPopup('.js-product__image, .js-product__image-main');
}

init();

$(window).on('shopify:section:load', function(event) {
	init();
});
